import React, { useState, useEffect } from 'react';
import { Button, notification } from 'antd';
import { CheckCircleTwoTone, ArrowLeftOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { storeSelector } from 'reduxStore/store/selectors';
import InputAmount from './InputAmount';
import QrScanCode from './QrScanCode';
import TransactionDetail from 'components/TransactionDetail';
import { ConnectSocket } from 'APIService/socket';
import { useTranslation } from 'react-i18next';
import { createTempTransaction } from 'APIService/transactionService';
import useAPILoading from 'hooks/useAPILoading';
import useCountDown from 'hooks/useCountDown';

const GenerateQrCodeLayout = styled.div`
  padding: 40px 20px 20px 20px;
  text-align: center;
  width: 100%;
  max-width: 900px;
  margin: auto;
  flex: auto;
`;

const STEP_INPUT_AMOUNT = 1;
const STEP_QR_SCAN_CODE = 2;
const STEP_TRANSACTION_DETAIL = 3;
const totalStep = 3;

const GenerateQrCode = () => {
  const { t } = useTranslation();
  const storeId = useSelector(storeSelector).id;
  const [qrCodeData, setQrCodeData] = useState();
  const [step, setStep] = useState(STEP_INPUT_AMOUNT);
  const [transactionData, setTransactionData] = useState();
  const [amountQrCode, setAmountQrCode] = useState();
  const [timeLeft, resetTime, runCountDown] = useCountDown(120, {
    auto: false,
  });
  const [callCreateTemp, loading] = useAPILoading(createTempTransaction);

  useEffect(() => {
    let socket = ConnectSocket(storeId);
    socket.on('connect', function () {
      setQrCodeData({ ...qrCodeData, socketId: socket.id });
    });
    socket.on('SOCKET_CREATE_TRANSACTION_SUCCESS', (response) => {
      setTransactionData(response.data);
      setStep(STEP_TRANSACTION_DETAIL);
      notification.open({
        message: `${t('createTransactionSuccess').toUpperCase()}`,
        icon: <CheckCircleTwoTone twoToneColor='#52c41a' />,
      });
    });
    return function cleanUp() {
      socket.close();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleBack() {
    setStep(step - 1);
  }

  function backToFirst() {
    setStep(STEP_INPUT_AMOUNT);
  }

  const handleGenerateQr = () => {
    callCreateTemp(amountQrCode).then((res) => {
      if (res.data && res.data.data) {
        resetTime();
        runCountDown();
        setQrCodeData({ ...qrCodeData, ...res.data.data });
        setStep(STEP_QR_SCAN_CODE);
      }
    });
    // TODO: error handling when generate failed
  };

  return (
    <GenerateQrCodeLayout>
      {step > 1 && step < totalStep && (
        <div style={{ display: 'flex' }}>
          <Button onClick={handleBack} icon={<ArrowLeftOutlined />}>
            {t('back')}
          </Button>
        </div>
      )}
      {step === STEP_INPUT_AMOUNT && (
        <InputAmount
          amount={amountQrCode}
          onChangeAmount={setAmountQrCode}
          onGenerateQrCode={handleGenerateQr}
          loading={loading}
        />
      )}
      {step === STEP_QR_SCAN_CODE && (
        <QrScanCode
          onPressChangeAmount={backToFirst}
          qrCodeData={qrCodeData}
          timeLeft={timeLeft}
          onPressRegenerateQr={handleGenerateQr}
          loading={loading}
        />
      )}
      {step === STEP_TRANSACTION_DETAIL && (
        <TransactionDetail
          transactionData={transactionData}
          handleBack={backToFirst}
        />
      )}
    </GenerateQrCodeLayout>
  );
};

export default GenerateQrCode;
